import { GetServerSidePropsContext } from 'next';
import CBRProvider from '../../../providers/cbr/cbr.provider';
import ContentfulProvider from '../../../providers/contentful';
import {
  partnersSectionCBRQuery,
  partnersSectionContentfulQuery,
} from './partners-section.query';
import {
  PartnersSectionCBRResponse,
  PartnersSectionContentfulResponse,
  PartnersSectionProperties,
  SORT_ITEMS,
} from './partners-section.types';
import { arrayToObject } from '../../../utils/array-to-object';

export const SORT_DEFAULT_KEY = 'merchantListFilterable.sort.mostPopular';

export const partnersSectionHandler = async ({
  req: { opco },
}: GetServerSidePropsContext): Promise<PartnersSectionProperties> => {
  const cbrResponse = await new CBRProvider(
    opco,
  ).makeCBRRequest<PartnersSectionCBRResponse>({
    query: partnersSectionCBRQuery,
    variables: {
      locale: opco.locale,
    },
    includeDefaultVariables: false,
  });

  const contentfulRequest = new ContentfulProvider(
    opco,
  ).makeContentfulRequest<PartnersSectionContentfulResponse>({
    query: partnersSectionContentfulQuery,
  });

  const contentfulResponse = await contentfulRequest;

  const content = arrayToObject(
    contentfulResponse.data.microcopyCollection.items,
  );

  const sortItems = contentfulResponse.data.microcopyCollection.items
    .filter(item => /^merchantListFilterable\.sort(?!\.sortBy)/.test(item.key))
    .map(item => ({
      label: item.value,
      value: SORT_ITEMS[item.key as keyof typeof SORT_ITEMS],
      isActive: item.key === SORT_DEFAULT_KEY,
    }));

  const formattedCategories = cbrResponse?.hasError
    ? []
    : cbrResponse.data.category_locale.map(item => ({
        name: item.name,
        slug: item.category?.slug,
      }));

  return {
    hasError: cbrResponse?.hasError,
    header: {
      allLabel: content['general.allLabel'] ?? '',
    },
    filters: {
      filterByLabel: content['merchantListFilterable.filter.filterBy'] ?? '',
      clearFiltersLabel:
        content['merchantListFilterable.filter.clearAllFilters'] ?? '',
      categories: formattedCategories,
    },
    sorting: {
      sortByLabel: content['merchantListFilterable.sort.sortBy'] ?? '',
      sortItems,
    },
    partners: {
      wasRateText: content['merchant.ratewas'] ?? '',
      rateUpTo: content['merchant.rateupto'] ?? '',
      fromText: content['merchant.ratefrom'] ?? '',
      speedyAwardText: content['speedyAward.title'] ?? '',
    },
    loadMore: {
      loadMoreLabel: content['loadMore.loadMore'] ?? '',
      ofLabel: content['loadMore.of'] ?? '',
    },
  };
};
